// extracted by mini-css-extract-plugin
module.exports = {"emphasizedText":"az_Jv","headline":"az_Kv"};